import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { getTestId, linkMatchesPath, neverActive } from './Sidebar.helpers'

export const SidebarCollapsedSection = ({
  accessor,
  title,
  icon,
  links = [],
  isFavoritesSection = false,
  currentPath,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const containsCurrentPath =
    !isFavoritesSection && links.some((link) => linkMatchesPath(link, currentPath))

  return (
    <InteractiveTooltip
      interactive
      placement="right-start"
      theme="light"
      open={isOpen}
      setOpen={setIsOpen}
      className="sidebar-flyout"
      content={
        <>
          <div className="sidebar-flyout__title">{title}</div>
          <nav className="sidebar-flyout__nav" aria-label={title}>
            {links.map((link) => (
              <NavLink
                key={link.path}
                data-testid={getTestId(link.path)}
                to={link.path}
                exact={link.exact}
                isActive={isFavoritesSection ? neverActive : link.isActive}
                onClick={() => setIsOpen(false)}
              >
                {link.icon}
                {link.label}
              </NavLink>
            ))}
          </nav>
        </>
      }
    >
      <button
        type="button"
        className={classNames('balto-sidebar__collapsed-icon', { active: containsCurrentPath })}
        aria-label={title}
        data-testid={`sidebar-collapsed-${accessor}`}
      >
        {icon}
      </button>
    </InteractiveTooltip>
  )
}
